<ng-container *ngFor="let item of items">
  <a [routerLink]="item.path">{{ item.title | transloco }}</a>
</ng-container>
